import {
  Box,
  Button,
  Chip,
  Grid2,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { MenuBook, Quiz as QuizIcon } from "@mui/icons-material";

const HomeSection = ({
  isCompact,
  onSelectView,
  quizCount,
  flashcardCount,
  loading,
}) => {
  const quizLabel = loading ? "Loading..." : `${quizCount} quiz sets`;
  const flashcardLabel = loading ? "Loading..." : `${flashcardCount} decks`;

  return (
    <Grid2 container spacing={3} alignItems="center">
      <Grid2 size={{ xs: 12, md: 7 }}>
        <Stack spacing={2}>
          <Chip
            icon={<QuizIcon />}
            label="Quizzes + Flashcards"
            color="secondary"
            sx={{ width: "fit-content" }}
          />
          <Typography variant={isCompact ? "h3" : "h2"}>
            Learning for everyone
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Select a subject and grade, then practice with randomized quizzes
            and explore auto-shuffled flashcards. Everything is organized to help
            you learn effectively.
          </Typography>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
            <Button
              variant="contained"
              size="large"
              onClick={() => onSelectView("quizzes")}
            >
              Go to quizzes
            </Button>
            <Button
              variant="contained"
              size="large"
              color="secondary"
              onClick={() => onSelectView("flashcards")}
            >
              Go to flashcards
            </Button>
          </Stack>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1.5}
            sx={{ mt: 1 }}
          >
            <Chip
              label="Grade 1-8"
              size="small"
              sx={{
                bgcolor: "action.selected",
                cursor: "default",
                "&:hover": { bgcolor: "action.selected" },
              }}
            />
            <Chip
              label={quizLabel}
              size="small"
              sx={{
                bgcolor: "action.selected",
                cursor: "default",
                "&:hover": { bgcolor: "action.selected" },
              }}
            />
            <Chip
              label={flashcardLabel}
              size="small"
              sx={{
                bgcolor: "action.selected",
                cursor: "default",
                "&:hover": { bgcolor: "action.selected" },
              }}
            />
          </Stack>
        </Stack>
      </Grid2>
      <Grid2 size={{ xs: 12, md: 5 }}>
        <Paper elevation={0} sx={{ p: 3, bgcolor: "background.paper" }}>
          <Stack spacing={2}>
            <Typography variant="h5">Study playlist</Typography>
            <Typography variant="body2" color="text.secondary">
              Choose a subject and grade, then explore randomized quizzes and
              auto-shuffled flashcards at your own pace. Small steps lead to
              mastery.
            </Typography>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={1} flexWrap="wrap">
              <Chip icon={<QuizIcon />} label="Quizzes" />
              <Chip icon={<MenuBook />} label="Flashcards" />
              <Chip label="Daily practice" />
            </Stack>
            <Box>
              <Typography variant="caption" color="text.secondary">
                Tip: Use the subject and grade dropdowns in the navbar to switch
                subjects and levels quickly.
              </Typography>
            </Box>
          </Stack>
        </Paper>
      </Grid2>
    </Grid2>
  );
};

export default HomeSection;
